import { SIDEBAR_ROUTE_CONFIG } from "../constants/appConstants";
import {
  createMenusService,
  getMenusService,
  updateMenusService,
} from "../services/menuService";
import { errorHandler } from "../utils/helpers";

const getMenuManager = async () => {
  const response = await errorHandler(getMenusService)();
  return {
    menuOptionsResponse: response?.data?.respData?.results,
    routeConfig:
      response?.data?.respData?.sidebarRouteConfig ??
      SIDEBAR_ROUTE_CONFIG.SERVER_ONLY,
  };
};

const updateMenusManager = async () => {
  const response = await errorHandler(updateMenusService)();
  return response;
};

const createMenusManager = async () => {
  const response = await errorHandler(createMenusService)();
  return response;
};

export { createMenusManager, getMenuManager, updateMenusManager };
